var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationsReadLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#EDEEF5",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#E3E5E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8452 24C17.0834 24.4125 17.5236 24.6666 17.9999 24.6666C18.4762 24.6666 18.9164 24.4125 19.1545 24",
    stroke: "#0C121A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1747 20.216C11.9967 20.4111 11.9507 20.6927 12.0572 20.9343C12.1637 21.1759 12.4027 21.3318 12.6667 21.332H23.3333C23.5973 21.3321 23.8365 21.1765 23.9433 20.935C24.0501 20.6936 24.0043 20.4119 23.8267 20.2167C22.94 19.3027 22 18.3314 22 15.332C22 13.1244 20.2077 11.332 18 11.332C15.7924 11.332 14 13.1244 14 15.332C14 18.3314 13.0593 19.3027 12.1747 20.216",
    stroke: "#0C121A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsReadLight);
export default __webpack_public_path__ + "static/media/notifications-read-light.084f0eadb049721163876c22c9c78136.svg";
export { ForwardRef as ReactComponent };